import React from "react";

export default function NotFoundPage() {
  return (
    <div
      style={{
        fontSize: "20rem",
        color: "#FFF",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      Not Found
    </div>
  );
}
